import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/search-results/components/SearchResultsInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
